// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3XRHQ","file":"styles_file__3Swm-"};